
import { HeaderIconsProps } from '@v2/components/imageHandling/components/Header/components/HeaderIcons';
import { StyleProp, ViewStyle } from 'react-native';
import svgRegister from '@styles/icons/svg/svgRegister';
import { SimpleOnPress } from '@interfaces/base';

export enum HeaderIconKey {
  CROP = 'crop',
  ROTATE = 'rotate',
  DRAW = 'draw',
  SHARE = 'share',
  ATTACH = 'attach',
  THUMBNAIL = 'thumbnail',
  ADD_IMAGE = 'addImage',
  DISPLAY_MODE = 'displayMode',
  MORE = 'more',
  CLOSE = 'close',
  COLLAPSE = 'collapse',
  EXPAND = 'expand',
}

export interface ImageHandlingHeaderIconConfig extends SimpleOnPress {
  key: HeaderIconKey;
  shouldDisplay: boolean;
  icon: keyof typeof svgRegister;
  width: number;
  height: number;
  color: string;
  isModalOpened?: boolean;
  containerStyles?: StyleProp<ViewStyle>;
  elementToTheRightOfIcon?: JSX.Element;
  trackPositionKey?: string; // Unique key for position tracking
  disabled?: boolean;
}

export interface UseManageHeaderIconsParams extends Omit<HeaderIconsProps, 'iconsContainerStyle'> {
  ref?: React.Ref<IconPositions>;
  enabledIcons?: HeaderIconKey[];
}

export interface IconPositions {
  [key: string]: { x: number; y: number } | undefined;
}
